import { createAction, props } from "@ngrx/store";

export const buscarEntrada = createAction(
  "[Search Input Component] buscar Entrada",
  props<{ busqueda: string; tipoBusqueda: string; request: any }>()
);

export const buscarEntradaSuccess = createAction(
  "[Search Input Component] buscar Entrada Success",
  props<{
    ids: any[];
    busqueda: string;
    pages: number;
    currentPage: number;
    tipoBusqueda: string;
  }>()
);

export const resetBusqueda = createAction(
  "[Search Input Component] reset Busqueda"
);

export const buscarEntradaFail = createAction(
  "[Search Input Component] buscar Entrada Fail"
);

export const loadingEntradas = createAction(
  "[Search Input Component] loading Entradas"
);

export const loadingAllEntradasForExportExcel = createAction(
  "[Search Input Component] loadingAllEntradasForExportExcel"
);
export const loadingAllEntradasForExportExcelSuccess = createAction(
  "[Search Input Component] loadingAllEntradasForExportExcelSuccess"
);
export const loadingAllEntradasForExportExcelFail = createAction(
  "[Search Input Component] loadingAllEntradasForExportExcelFail"
);
export const loadingEntradasSuccess = createAction(
  "[Search Input Component] loading Entradas Success",
  props<{ entradas: any[]; currentPage: number }>()
);

export const entradasLoaded = createAction(
  "[Search Input Component] entradas Loaded"
);

export const loadingEntradasFail = createAction(
  "[Search Input Component] loading Entradas Fail"
);

export const exportEntradas = createAction(
  "[Search Input Component] export Entradas"
);
export const exportEntradasFail = createAction(
  "[Search Input Component] export Entradas Fail"
);
export const exportEntradasSuccess = createAction(
  "[Search Input Component] export Entradas Success"
);

export const loadEntradaSeleccionada = createAction(
  "[Search Input Component] loadEntradaSeleccionada",
  props<{ entrada: any }>()
);
